export const STANDARD_SERVINGS_PER_MEAL = [2, 4, 6];
export const FAMILY_SERVINGS_PER_MEAL = [2, 4];
